<template>
    <div class="container">
            <div class="row justify-content-center">
               <div class="col-md">
                <div class="card bg-dark p-2" style="font-size: 18px; color: #aaa">
                    <p class="h4 card-header border-light">{{$t('AdminDashboard.headings.information')}}</p>
                    <p class="card-body text-left" v-html="$t('Content.Information.main')"></p>
                </div>
                </div>
            </div>
        </div>
</template>



<script>
import AuthService from "@/services/AuthService.ts"


export default ({
    name: 'AddressMain',
    components: {

    },
    async mounted() {
        AuthService.authorize();
    }
})
</script>

<style scoped>

</style>